module.exports = __webpack_public_path__ + "static/media/emoji_heart_eyes.e3d7ba7b.svg";